import { ConfirmModelConfig } from 'liyu-pc-base/api/typing';

import { useUserStore } from 'liyu-pc-base/init-plugin';

import { Modal } from 'ant-design-vue';
import Handlebars from 'handlebars';
import { HeadBtnConfig } from 'liyu-pc-base/api/typing';
import { useRequest } from 'liyu-pc-base/init-plugin';
import { getObjListBySelectedRowKeys } from 'liyu-pc-base/utils/function';
import { unref } from 'vue';

export const head_btn_confirm = ({
  dataSource,
  button,
  selectedRowKeys,
  event_obj,
}: {
  dataSource: any[];
  button: HeadBtnConfig;
  selectedRowKeys: any[];
  event_obj: any;
}) => {
  const request = useRequest();
  selectedRowKeys = unref(selectedRowKeys);
  const preProcessData = button.preProcessData;
  const model_config = button.model_config as ConfirmModelConfig;
  const init_data = model_config.init_data;
  const batch_api_fields = model_config.batch_api_fields;
  const title = model_config.title;
  const content = model_config.content;
  const ok_url = model_config.ok_url;
  const cancel_url = model_config.cancel_url;
  const method = model_config.method || 'post';
  const userStore = useUserStore();
  const current_org = userStore.currentOrg; // 当前组织org
  const org_id = current_org?.id;
  let api_data = dataSource as any;
  if (preProcessData) {
    api_data = preProcessData({ dataSource, selectedRowKeys });
  }
  if (batch_api_fields) {
    api_data = getObjListBySelectedRowKeys(batch_api_fields, dataSource, selectedRowKeys);
  }
  if (init_data) {
    api_data = { ...api_data, ...init_data };
  }
  api_data = { ...api_data, org_id };

  const titleTemplate = Handlebars.compile(title || '');
  const contentTemplate = Handlebars.compile(content || '');

  Modal.confirm({
    title: titleTemplate({ record: api_data }),
    content: contentTemplate({ record: api_data }),
    onOk() {
      if (ok_url) {
        request[method](ok_url, api_data).then(() => {
          event_obj.emit('refresh');
        });
      }
    },
    onCancel() {
      if (cancel_url) {
        request[method](cancel_url, api_data).then(() => {
          event_obj.emit('refresh');
        });
      }
    },
  });
};
